module.exports = __webpack_public_path__ + "static/media/01_NXV1270A.faf800be.png";